import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import AdminRoutes from './routes/AdminRoutes';
import UserRoutes from './routes/UserRoutes';
import CollegeRoutes from './routes/CollegeRoutes';
import BosRoutes from './routes/BosRoute';
import SFARoutes from './routes/SFARoutes';
import IMURoutes from './routes/IMURoutes';
import Error404 from './Pages/Error404';
import IS from './routes/IS';

function App() {
  return (
    <Router > 
      <Routes>
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/college/*" element={<CollegeRoutes />} />
        <Route path="/bos/*" element={<BosRoutes />} />
        <Route path="/sfa/*" element={<SFARoutes />} />
        <Route path="/ino/*" element={<IMURoutes />} />
        <Route path="/is/*" element={<IS/>} />
        <Route path="/*" element={<UserRoutes />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
